// 登录模块

// Home模块
import Home from "../view/home"
import SaleDetail from "../view/saleDetail"
import SalePay from "../view/salePay"

import APE from "../view/ape";
import NftPad from "@/view/nftPad";
// 我的模块
import Mine from "../view/mine"
import MyCollection from "../view/myCollection"
import MyCollectionSearch from "../view/myCollectionSearch"
import MyCollectionDetail from "../view/myCollectionDetail"
import SecondCreationAgreement from "../view/secondCreationAgreement"

import {CollectionList, CollectionVote,EditSuggest,CollectionRaffle, RaffleShare,CreateCommunity} from '@/view/myCollectionVote/index'


import CartoonCollection from '@/view/cartoonCollection/index'
import UpgradeHistory from '@/view/cartoonCollection/upgradeHistory'

import CartoonSaleDetail from '@/view/apeWorld/cartoonSaleDetail'

import MyOrder from "../view/myOrder"
import MyOrderDetail from "../view/myOrderDetail"
import MyGroupOrder from "../view/myGroupOrder"
import GroupOrderDetail from "../view/myGroupOrder/groupOrderDetail"

import MyMysteryBox from "../view/myMysteryBox"
import MyAgreement from "@/view/myAgreement"
import DonationInfo from '../view/donationInfo'
import Error from "../view/Error"
import DonationSuccess from '../view/donationSuccess';
import ReceiveDonation from '../view/receiveDonation';
import ReceiveResult from '../view/receiveResult';
import HotAss from '../view/hot';
import TransferRecord from '../view/transferRecord';
import ApeWorldSaleDetail from '../view/apeWorldSaleDetail';
import ApeWorldSalePay from "../view/apeWorldSalePay";
import AllSaintsDaySaleDetail from "../view/allSaintsDaySaleDetail";
import {ShopStageHome} from "@/view/shopStage1";
import ShopCartSalePay from "@/view/shopCartSalePay";
import ShopProductDetail from "@/view/shopStage1/views/shopProductDetail";
import ShopPaySuccess from "@/view/shopPaySuccess";
import {EggHatch,} from "@/view/eggHatch";
import {EggHatchProgress} from "@/view/eggHatch/views/eggHatchProgress";
import EggHatchSuccess from "@/view/eggHatch/views/eggHatchSuccess";
import EggHatchProductDetail from "@/view/eggHatch/views/eggHatchProductDetail";
import variationApe from "@/view/variationApe"

import CartoonShare from '@/view/share/CartoonShare/index'
import BlockChainQuery from "@/view/blockChainQuery";
import {BlockChainAdrInfo, BlockChainInfo} from "@/view/blockChainQuery/components/blockChainAdrInfo";
import {BlockChainColInfo} from "@/view/blockChainQuery/components/blockChainColInfo";
import {BoringApeClub} from "@/view/boringApeClub";
import {NftSetting, PwdResert, PwdSetting} from "@/view/nftSetting";
import partsRecycling from "@/view/partsRecycling";

import RecoveryLand from "@/view/collectionRecoveryLand";

import MyCollectionSearchResult from "@/view/myCollectionSearch/collectionSearchResult";
import MyCollectionSearchNavigation from "@/view/myCollectionSearch/collectionSearchNavigation";

import MyCoupon from "@/view/myCoupon";
import Pay from "@/view/pay";
import PaySuccess from "@/view/pay/success/index";
import guessingActy from "@/view/guessingActy";
import {MoviegoerTicket} from "@/view/myCollectionVote";
import partsRecyclingUnity from "@/view/partsRecyclingUnity";
import colCompound from "@/view/colCompound";
import collectionSynthesis from "@/view/collectionSynthesis";
import EnviroProDetail from "@/view/enviroProDetail";
import ExchangeSucc from "@/view/enviroProDetail/exchangeSucc";

// LandGame
import GameMain from "@/view/landGame/index";
import LandGame from "@/view/landGame/home";
import LandDetail from "@/view/landGame/landDetail"
import EleCompoundHome from "@/view/eleCompound/home";
import JewelLand from "@/view/landGame/jewelLand";
import LeaseCenter from "@/view/landGame/leaseCenter";
import RentOut from "@/view/landGame/leaseCenter/rentOut";
import RentOutDetail from "@/view/landGame/leaseCenter/rentOut/detail";

import WorkapeBlindbox from "@/view/workApeBlindbox";
import SpaceBeautifulAccount from "@/view/spaceBeautifulAccount"
//欧洲杯
import Eurocup from "@/view/eurocup";
// 配件盲盒
import PartsBlindbox from "@/view/apeWorld/partsBlindbox";
import KangYangNFT from "@/view/kangYangNFT";
// 工业猿
import IndustrialApe from "@/view/industrialApe";
// 盲盒转宝石
import BoxToStone from "@/view/boxToStone";
// 王小慧盲盒
import WangXiaoHui from "@/view/wangXiaoHui";
// 盲盒拆拆乐
import Blindbox from "@/view/blindBox";
import PurchaseRebate from "@/view/purchaseRebate";
import WoodGrainBadge from "@/view/woodGrainBadge";
import Supperzzle from "@/view/supperzzle";
import CulturalExchange from "@/view/culturalExchange"
import GetGuardsBenefit from "@/view/culturalExchange/getGuardsBenefit";
import CulturalExchange_gold from "@/view/culturalExchange_gold";
import CulturalExchange_seasons from "@/view/culturalExchange_seasons";
import CulturalExchange_joker from "@/view/culturalExchange_joker";
import CulturalExchange_kangyang from "@/view/culturalExchange_kangyang";
import CulturalExchange_maotaisecond from "@/view/culturalExchange_maotaisecond";
import CulturalExchange_onplane from "@/view/culturalExchange_onplane";
import CulturalExchange_euro from "@/view/culturalExchange_euro";
import CulturalExchange_euro2 from "@/view/culturalExchange_euro2";
import CulturalExchange_mazu from "@/view/culturalExchange_mazu";
import CulturalExchange_greencarbon from "@/view/culturalExchange_greencarbon";
import CulturalExchange_integral from "@/view/culturalExchange_integral";
import CulturalExchange_taijigreencarbon from "@/view/culturalExchange_taijigreencarbon";
import DunHuang from '@/view/dunHuang'
import WorldCup2026 from '@/view/worldCup2026'
import CulturalExchange_huaju from "@/view/culturalExchange_huaju";
import CulturalExchange_gemstonerecycling from "@/view/culturalExchange_gemstonerecycling";

function routerInteceptor(params) {
}

const routes = [
    {
        path: "/",
        element: <Home/>,
        title: "首页",
    },
    {
        path: "*",
        element: <Error/>,
        title: "error",
    },
    {
        path: "/notFond",
        element: <Error/>,
        title: "404",
    },
    {
        path: "/serverErr",
        element: <Error context="活动过于火爆，请您稍后重试~"/>,
        title: "server error",
    },
    {
        path: "/mine",
        element: <Mine/>,
        title: "我的",
    },

    // NOTE: Home模块
    {
        path: "/saleDetail",
        element: <SaleDetail/>,
        title: "发售详情",
    },
    {
        path: "/salePay",
        element: <SalePay/>,
        title: "订单支付",
    },
    {
        path: "/pay",
        element: <Pay />,
        title: "订单支付",
    },
    {
        path: "/pay/success",
        element: <PaySuccess />,
        title: "支付成功",
    },
    {
        path: "/ape/PaySuccess",
        element: <APE.PaySuccess/>,
        title: "支付成功",
    },
    {
        path: "/ape/saleDetail",
        element: <APE.SaleDetail/>,
        title: "发售详情",
    },
    {
        path: "/ape/PayPage",
        element: <APE.PayPage/>,
        title: "订单支付",
    },
    {
        path: "/ape/DefaultPay",
        element: <APE.DefaultPay/>,
        title: "订单支付",
    },

    // NOTE: 我的模块
    {
        path: "/myCollection",
        element: <MyCollection/>,
        title: "我的数字资产",
    },
    {
        path: "/myCollectionSearch",
        element: <MyCollectionSearch/>,
        title: "藏品搜索",
    },
    {
        path: "/myCollectionSearchNavigation",
        element: <MyCollectionSearchNavigation/>,
        title: "搜索结果页面",
    },
    {
        path: "/myCollectionSearchResult",
        element: <MyCollectionSearchResult/>,
        title: "藏品搜索导航页面",
    },
    {
        path: "/donationInfo",
        element: <DonationInfo/>,
        title: "转赠信息填写",
    },
    {
        path: "/donationSuccess",
        element: <DonationSuccess/>,
        title: "已成功发起转赠",
    },
    {
        path: "/receiveDonation",
        element: <ReceiveDonation/>,
        title: "接收转赠",
    },
    {
        path: "/receiveResult",
        element: <ReceiveResult/>,
        title: "",
    },
    {
        path: "/transferRecord",
        element: <TransferRecord/>,
        title: "转赠记录",
    },
    {
        path: "/myAgreement",
        element: <MyAgreement/>,
        title: "用户协议",
    },
    {
        path: "/myCollectionDetail",
        element: <MyCollectionDetail/>,
        title: "藏品详情",
    },
    {
        path: "/secondCreationAgreement",
        element: <SecondCreationAgreement/>,
        title: "二次创作及商业使用权说明",
    },
    {
        path: "/myMysteryBox",
        element: <MyMysteryBox/>,
        title: "盲盒抽奖",
    },
    {
        path: "/myOrder",
        element: <MyOrder/>,
        title: "我的订单",
    },
    {
        path: "/myOrderDetail",
        element: <MyOrderDetail/>,
        title: "订单详情",
    },
    {
        path: "/myGroupOrder",
        element: <MyGroupOrder/>,
        title: "我的订单",
    },
    {
        path: "/myGroupOrder/groupOrderDetail",
        element: <GroupOrderDetail/>,
        title: "订单详情",
    },
    {
        path: "/myCoupon",
        element: <MyCoupon />,
        title: "我的优惠券",
    },
    {
        path: "/hot",
        element: <HotAss/>,
        title: "稍后重试",
    },
    {
        path: "/apeWorldSaleDetail",
        element: <ApeWorldSaleDetail/>,
        title: "发售详情",
    },
    {
        path: "/allSaintsDaySaleDetail",
        element: <AllSaintsDaySaleDetail/>,
        title: "发售详情",
    },
    {
        path: "/apeWorldSalePay",
        element: <ApeWorldSalePay/>,
        title: "订单支付",
    },
    {
        path: "/shopStageHome",
        element: <ShopStageHome/>,
        title: "购物车首页",
    },
    {
        path: "/shopCartSalePay",
        element: <ShopCartSalePay/>,
        title: "订单支付",
    },
    {
        path: "/shopProductDetail",
        element: <ShopProductDetail/>,
        title: "商品详情",
    },

    {
        path: "/shopPaySuccess",
        element: <ShopPaySuccess/>,
        title: "支付成功",
    },
    {
        path:'/landGame/index',
        element: <GameMain />,
        title:'土地入口'
    },
    {
        path:'/landGame',
        element: <LandGame></LandGame>,
        title:'元宇宙土地'
    },
    {
      path:'/landGame/landDetail',
      element: <LandDetail></LandDetail>,
      title:'元宇宙土地'
    },
    {
        path: "/landGame/jewelLand",
        element: <JewelLand />,
        title: "",
    },
    {
        path: "/landGame/leaseCenter",
        element: <LeaseCenter />,
        title: "",
    },
    {
        path: "/landGame/rentOut",
        element: <RentOut />,
        title: "",
    },
    {
        path: "/landGame/rentOutDetail",
        element: <RentOutDetail/>,
        title: "",
    },
    {
        path: "/eggHatch",
        element: <EggHatch/>,
        title: "数字藏品",
    },
    {
        path: "/eggHatchProgress",
        element: <EggHatchProgress/>,
        title: "数字藏品",
    },
    {
        path: "/eggHatchSuccess",
        element: <EggHatchSuccess/>,
        title: "数字藏品",
    },
    {
        path: "/eggHatchProductDetail",
        element: <EggHatchProductDetail/>,
        title: "数字藏品",
    },
    {
        path: "/myCollectionVote/collectionList",
        element: <CollectionList/>,
        title: "共创意见征集",
    },
    {
        path: "/myCollectionVote/collectionVote",
        element: <CollectionVote/>,
        title: "Ape World -共创意见征集",
    },
    {
        path: "/myCollectionVote/editSuggest",
        element: <EditSuggest/>,
        title: "Ape World -共创意见征集",
    },
    {
        path: "/cartoonCollection",
        element: <CartoonCollection/>,
        title: "共创漫画数字藏品",
    },
    {
        path: "/cartoonCollection/upgradeHistory",
        element: <UpgradeHistory/>,
        title: "升级记录",
    },
    {
        path: "/apeWorld/cartoonSaleDetail",
        element: <CartoonSaleDetail/>,
        title: "共创漫画发行详情",
    },
    {
        path: "/apeWorld/paypage",
        element: <APE.PayPage/>,
        title: "订单支付",
    },
    {
        path: "/share/cartoonShare",
        element: <CartoonShare/>,
        title: "共创漫画分享",
    },
    {
        path: "variationApe/home",
        element: <variationApe.VariationHome/>,
        title: "",
    },
    {
        path: "variationApe/medicine",
        element: <variationApe.VariationMedicine/>,
        title: "变异药水",
    },
    {
        path: "variationApe/share",
        element: <variationApe.VariationApeShare/>,
        title: "",
    },
    {
        path: "variationApe/invite/success",
        element: <variationApe.VariationApeInviteSuccess/>,
        title: "",
    },
    {
        path: "variationApe/compose",
        element: <variationApe.ApeCompose/>,
        title: "变异无聊猿",
    },
    {
        path: "variationApe/medicine/record",
        element: <variationApe.VariationRecord/>,
        title: "药水合成记录",
    },
    {
        path: "variationApe/saleDetail",
        element: <variationApe.VariationApeSaleDetail/>,
        title: "",
    },
    {
        path: "/blockChainQuery",
        element: <BlockChainQuery/>,
        title: "链上查询",
    },
    {
        path: "/blockChainAdrInfo",
        element: <BlockChainAdrInfo/>,
        title: "区块链地址信息",
    },
    {
        path: "/blockChainColInfo",
        element: <BlockChainColInfo/>,
        title: "区块链藏品信息",
    },
    {
        path: "/boringApeClub",
        element: <BoringApeClub/>,
        title: "dodo社区",
    },
    {
        path: "/nftSetting",
        element: <NftSetting/>,
        title: "数字藏品设置",
    },
    {
        path: "/pwdSetting",
        element: <PwdSetting/>,
        title: "数字藏品设置",
    },
    {
        path: "/pwdResert",
        element: <PwdResert/>,
        title: "重置密码",
    },
    {
        path: "/partsRecycling/home",
        element: <partsRecycling.PartsRecyclingHome/>,
        title: "",
    },
    {
        path: "/partsRecycling/record",
        element: <partsRecycling.RecyclingRecord/>,
        title: "回收记录",
    },
    {
        path: "/partsRecycling/recovery",
        element: <partsRecycling.RecoveryParts/>,
        title: "回收配件",
    },
    {
        path: "/partsRecycling/share",
        element: <partsRecycling.RecyclingShareSuccess/>,
        title: "",
    },
    {
        path: "/partsRecycling/partsRecovery",
        element: <partsRecycling.PartsRecovery/>,
        title: "中奖记录",
    },
    {
        path: "/collectionRecoveryLand/home",
        element: <RecoveryLand.Home/>,
        title: "藏品回收",
    },
    {
        path: "/collectionRecoveryLand/recycling",
        element: <RecoveryLand.Recycling/>,
        title: "藏品回收",
    },
    {
        path: "/collectionRecoveryLand/recoveryRecord",
        element: <RecoveryLand.RecoveryRecord/>,
        title: "回收记录",
    },
    {
      path: "/myCollectionVote/share",
      element: <RaffleShare />,
      title: "",
    },
    {
        path: "/myCollectionVote/collectionRaffle",
        element: <CollectionRaffle/>,
        title: "积分抽奖",
    },
    {
        path: "/myCollectionVote/createCommunity",
        element: <CreateCommunity/>,
        title: "Ape World共创社区",
    },
    {
        path: "/guessingActy/home",
        element: <guessingActy.GuessingActyHome/>,
        title: "",
    },
    {
        path: "/guessingActy/getCoupon",
        element: <guessingActy.GetCoupon/>,
        title: "",
    },
    {
        path: "/guessingActy/exchangeRecord",
        element: <guessingActy.GuessingExchangeRecord />,
        title: "兑换纪录",
    },
    {
        path: "/guessingActy/rule",
        element: <guessingActy.GuessingActyRule/>,
        title: "竞猜攻略",
    },
    {
        path: "/guessingActy/exchangeStore",
        element: <guessingActy.GuessingExchangeStore/>,
        title: "兑换商城",
    },
    {
        path: "/guessingActy/exchangeOrder",
        element: <guessingActy.GuessingExchangeOrder />,
        title: "兑换订单",
    },
    {
        path: "/guessingActy/exchangeOrderDetails",
        element: <guessingActy.GuessingExchangeOrderDetails/>,
        title: "订单详情",
    },
    {
        path: "/guessingActy/exchangeRealOrderDetails",
        element: <guessingActy.GuessingExchangeRealOrderDetails/>,
        title: "订单详情",
    },
    {
        path: "/guessingActy/enshrine",
        element: <guessingActy.GuessingEnshrineDetails />,
        title: "绿地变异无聊猿数字藏品",
    },
    {
        path: "/guessingActy/sessionDetail",
        element: <guessingActy.SessionDetail/>,
        title: "竞猜详情",
    },
    {
        path: "/guessingActy/allSession",
        element: <guessingActy.AllSession/>,
        title: "全部场次",
    },
    {
        path: "/guessingActy/orderConfirmVirtual",
        element: <guessingActy.OrderConfirmVirtual/>,
        title: "确认订单",
    },
    {
        path: "/guessingActy/orderConfirmReal",
        element: <guessingActy.OrderConfirmReal/>,
        title: "确认订单",
    },
    {
        path: "/myCollectionVote/moviegoerTicket",
        element: <MoviegoerTicket/>,
        title: "观演人信息",
    },
    {
        path: "/partsRecyclingUnity/home",
        element: <partsRecyclingUnity.PartsRecyclingHomeUnity/>,
        title: "",
    },
    {
        path: "/partsRecyclingUnity/recycleRecord",
        element: <partsRecyclingUnity.RecycleRecord/>,
        title: "",
    },
    {
        path: "/colCompound/home",
        element: <colCompound.ColCompoundHome/>,
        title: "藏品合成",
    },
    {
        path: "/colCompound/test",
        element: <colCompound.Test/>,
        title: "测试",
    },
    {
        path: "/collectionSynthesis",
        element: <collectionSynthesis.Home/>,
        title: "藏品合成",
    },
    {
        path: "/collectionSynthesis/home",
        element: <collectionSynthesis.Home/>,
        title: "藏品合成",
    },
    {
        path: "/collectionSynthesis/record",
        element: <collectionSynthesis.Record/>,
        title: "合成记录",
    },
    {
        path: "/enviroProDetail",
        element: <EnviroProDetail/>,
        title: "",
    },
    {
        path: "/exchangeSucc",
        element: <ExchangeSucc/>,
        title: "兑换成功",
    },
    {
        path: "/eleCompoundHome",
        element: <EleCompoundHome/>,
        title: "",
    },
    {
      path: "/workapeBlindbox/home",
      element: <WorkapeBlindbox.BlindboxHome/>,
      title: "",
    },
    {
      path: "/workapeBlindbox/upgradeRecord",
      element: <WorkapeBlindbox.UpgradeRecord/>,
      title: "",
    },
    {
      path: "/workapeBlindbox/upgrade",
      element: <WorkapeBlindbox.UpgradeS/>,
      title: "",
    },
    {
      path: "/spaceBeautifulAccount",
      element: <SpaceBeautifulAccount/>,
      title: "",
    },
    {
        path: "/eurocup/home",
        element: <Eurocup.Home/>,
        title: "欧洲杯",
    },
    {
        path: "/apeWorld/partsBlindbox/home",
        element: <PartsBlindbox.Home/>,
        title: "ape world 配件盲盒",
    },
    {
        path: "/apeWorld/partsBlindbox/up-exchange",
        element: <PartsBlindbox.UpExchange/>,
        title: "兑换",
    },
    {
        path: "/apeWorld/partsBlindbox/exchangeHistory",
        element: <PartsBlindbox.ExchangeHistory/>,
        title: "兑换记录",
    },
    {
        path: "/kangyang-nft/lanhu",
        element: <KangYangNFT.LanHu/>,
        title: "蓝湖",
    },
    {
        path: "/kangyang-nft/home",
        element: <KangYangNFT.Home/>,
        title: "康养藏品",
    },
    {
        path: "/kangyang-nft/mergeHistory",
        element: <KangYangNFT.MergeHistory/>,
        title: "权益获得记录",
    },
    {
        path: "/industrialApe/home",
        element: <IndustrialApe.Home/>,
        title: "工业猿",
    },
    {
        path: "/industrialApe/synthesis",
        element: <IndustrialApe.Synthesis/>,
        title: "工业猿合成",
    },
    {
        path: "/industrialApe/synthesisRecord",
        element: <IndustrialApe.SynthesisRecord/>,
        title: "工业猿合成记录",
    },
    {
        path: "/boxToStone/home",
        element: <BoxToStone.Home/>,
        title: "盲盒转宝石",
    },
    {
        path: "/boxToStone/goodsDetail",
        element: <BoxToStone.GoodsDetail/>,
        title: "商品详情",
    },
    {
        path: "/boxToStone/confirmOrder",
        element: <BoxToStone.ConfirmOrder/>,
        title: "确认订单",
    },
    {
        path: "/boxToStone/batchTransform",
        element: <BoxToStone.BatchTransform/>,
        title: "批量转化",
    },
    {
        path: "/boxToStone/buyHistory",
        element: <BoxToStone.BuyHistory/>,
        title: "购买记录",
    },
    {
        path: "/boxToStone/paySuccess",
        element: <BoxToStone.PaySuccess/>,
        title: "支付成功",
    },
    {
        path: "/wangXiaoHui/home",
        element: <WangXiaoHui.Home/>,
        title: "王小慧盲盒",
    },
    {
        path: "/wangXiaoHui/prize",
        element: <WangXiaoHui.Prize/>,
        title: "中奖记录",
    },
    {
        path: "/blindbox/home",
        element: <Blindbox.Home/>,
        title: "惊喜盲盒拆拆乐",
    },
    {
        path: "/blindbox/openHistory",
        element: <Blindbox.OpenHistory/>,
        title: "记录",
    },
    {
        path: "/blindbox/share",
        element: <Blindbox.BlindBoxShare/>,
        title: "",
    },
    {
        path: "/blindbox/invite/success",
        element: <Blindbox.BlindBoxInviteSuccess/>,
        title: "",
    },
    {
        path: "/purchaseRebate/home",
        element: <PurchaseRebate.Home/>,
        title: "藏品购买返利",
    },
    {
        path: "/purchaseRebate/rebateList",
        element: <PurchaseRebate.RebateList/>,
        title: "返还记录",
    },
    {
        path: "/woodGrainBadge/home",
        element: <WoodGrainBadge.Home/>,
        title: "木纹徽章",
    },
    {
        path: "/woodGrainBadge/buyBack",
        element: <WoodGrainBadge.BuyBack/>,
        title: "木纹徽章回购",
    },
    {
        path: "/woodGrainBadge/seeBuyBackList",
        element: <WoodGrainBadge.SeeBuyBackList/>,
        title: "木纹徽章回购记录",
    },
    {
        path: "/woodGrainBadge/seeCompoundList",
        element: <WoodGrainBadge.SeeCompoundList/>,
        title: "木纹徽章合成记录",
    },
    {
        path: "/supperzzle/home",
        element: <Supperzzle.Home/>,
        title: "对对碰",
    },
    {
        path: "/supperzzle/exchangeMall",
        element: <Supperzzle.ExchangeMall/>,
        title: "兑换商城",
    },
    {
        path: "/supperzzle/exchangeRecord",
        element: <Supperzzle.ExchangeRecord/>,
        title: "兑换记录",
    },
    {
        path: "/supperzzle/buyPowerRecord",
        element: <Supperzzle.BuyPowerRecord/>,
        title: "购买记录",
    },
    {
        path: "/supperzzle/powerPay",
        element: <Supperzzle.PowerPay/>,
        title: "购买体力支付",
    },
    {
        path: '/culturalExchange/home',
        element: <CulturalExchange.Home/>,
        title: '文交所'
    },
    {
        path: '/culturalExchange/thirteenGuards',
        element: <CulturalExchange.ThirteenGuards/>,
        title: '十三太保图鉴'
    },
    {
        path: '/culturalExchange/getGuardsBenefit',
        element: <CulturalExchange.GetGuardsBenefit/>,
        title: '藏品权益领取'
    },{
        path: '/culturalExchange_gold/home',
        element: <CulturalExchange_gold.Home/>,
        title: '文交所二期'
    },{
        path: '/culturalExchange_seasons/home',
        element: <CulturalExchange_seasons.Home/>,
        title: '茅台联名'
    },{
        path: '/culturalExchange_seasons/collectionRecord',
        element: <CulturalExchange_seasons.CollectionRecord/>,
        title: '茅台联名订单记录'
    },{
        path: '/culturalExchange_seasons/LandingPage',
        element: <CulturalExchange_seasons.LandingPage/>,
        title: '茅台联名落地页'
    },{
        path: '/culturalExchange_joker/home',
        element: <CulturalExchange_joker.Home/>,
        title: '扑克牌'
    },{
        path: '/culturalExchange_kangyang/home',
        element: <CulturalExchange_kangyang.Home/>,
        title: '康养藏品'
    },{
        path: '/culturalExchange_kangyang/collectionRecord',
        element: <CulturalExchange_kangyang.CollectionRecord/>,
        title: '规则'
    },{
        path: '/culturalExchange_maotaisecond/home',
        element: <CulturalExchange_maotaisecond.Home/>,
        title: '茅台二期'
    },{
        path: '/culturalExchange_maotaisecond/collectionRecord',
        element: <CulturalExchange_maotaisecond.CollectionRecord/>,
        title: '茅台2期订单记录'
    },{
        path: '/culturalExchange_maotaisecond/exchangepage',
        element: <CulturalExchange_maotaisecond.ExchangePage/>,
        title: '茅台2期兑换'
    },{
        path: '/culturalExchange_maotaisecond/exchangeRecord',
        element: <CulturalExchange_maotaisecond.ExchangeRecord/>,
        title: '茅台2期兑换记录'
    },{
        path: '/culturalExchange_onplane/home',
        element: <CulturalExchange_onplane.Home/>,
        title: '在飞机'
    },{
        path: '/culturalExchange_euro/home',
        element: <CulturalExchange_euro.Home/>,
        title: '欧冠1期'
    },{
        path: '/culturalExchange_euro2/home',
        element: <CulturalExchange_euro2.Home/>,
        title: '欧冠2期'
    },{
        path: '/culturalExchange_huaju/home',
        element: <CulturalExchange_huaju.Home/>,
        title: '话剧藏品'
    },{
        path: '/culturalExchange_huaju/exchangepage',
        element: <CulturalExchange_huaju.ExchangePage/>,
        title: '话剧合成'
    },{
        path: '/culturalExchange_huaju/exchangeRecord',
        element: <CulturalExchange_huaju.ExchangeRecord/>,
        title: '已合成藏品'
    },{
        path: '/culturalExchange_huaju/collectionRecord',
        element: <CulturalExchange_huaju.CollectionRecord/>,
        title: '话剧订单记录'
    },{
        path: '/culturalExchange_mazu/home',
        element: <CulturalExchange_mazu.Home/>,
        title: '妈祖藏品'
    },{
        path: '/culturalExchange_greencarbon/home',
        element: <CulturalExchange_greencarbon.Home/>,
        title: '绿碳藏品'
    },{
        path: '/culturalExchange_greencarbon/collectionRecord',
        element: <CulturalExchange_taijigreencarbon.CollectionRecord/>,
        title: '我的申请'
    },{
        path: '/culturalExchange_greencarbon/addApply',
        element: <CulturalExchange_greencarbon.AddApply/>,
        title: '新增申请'
    },{
        path: '/culturalExchange_greencarbon/applyDetail',
        element: <CulturalExchange_greencarbon.ApplyDetail/>,
        title: '申请详情'
    },{
        path: '/culturalExchange_integral/home',
        element: <CulturalExchange_integral.Home/>,
        title: '藏品购买换积分'
    },{
        path: '/culturalExchange_integral/exchangepage',
        element: <CulturalExchange_integral.ExchangePage/>,
        title: '藏品回收'
    },{
        path: '/culturalExchange_integral/recycleSelect',
        element: <CulturalExchange_integral.RecycleSelect/>,
        title: '请选择藏品'
    },{
        path: '/culturalExchange_integral/recycleRecord',
        element: <CulturalExchange_integral.RecycleRecord/>,
        title: '回收记录'
    },{
        path: '/culturalExchange_integral/exchangeRecord',
        element: <CulturalExchange_integral.ExchangeRecord/>,
        title: '回收记录'
    },{
        path: '/culturalExchange_taijigreencarbon/home',
        element: <CulturalExchange_taijigreencarbon.Home/>,
        title: '太极绿碳藏品'
    },{
        path: '/culturalExchange_taijigreencarbon/morepage',
        element: <CulturalExchange_taijigreencarbon.MorePage/>,
        title: '太极绿碳藏品更多'
    },{
        path: '/culturalExchange_taijigreencarbon/collectionRecord',
        element: <CulturalExchange_taijigreencarbon.CollectionRecord/>,
        title: '我的申请'
    },{
        path: '/culturalExchange_taijigreencarbon/addApply',
        element: <CulturalExchange_taijigreencarbon.AddApply/>,
        title: '新增申请'
    },{
        path: '/culturalExchange_taijigreencarbon/applyDetail',
        element: <CulturalExchange_taijigreencarbon.ApplyDetail/>,
        title: '申请详情'
    },
    {
        path: '/dunHuang/home',
        element: <DunHuang.Home/>,
        title: '敦煌藏品'
    },
    {
        path: '/nftPad/saleDetail',
        element: <NftPad.SaleDetail/>,
        title: '发售详情'
    },
    {
        path: '/nftPad/payPage',
        element: <NftPad.PayPage/>,
        title: '藏品订单支付'
    },
    {
        path: '/nftPad/paySuccess',
        element: <NftPad.PaySuccess/>,
        title: '支付成功'
    },
    {
        path: '/nftPad/benefitGet',
        element: <NftPad.BenefitGet/>,
        title: '藏品权益领取'
    },
    {
        path: '/nftPad/rightsOrder',
        element: <NftPad.RightsOrder/>,
        title: '权益领取-确认订单'
    },
    {
        path: '/nftPad/orderDetail',
        element: <NftPad.OrderDetail/>,
        title: '权益领取-订单详情'
    },
    {
        path: '/worldCup2026/home',
        element: <WorldCup2026.Home/>,
        title: '2026世界杯'
    },    {
        path: '/culturalExchange_gemstonerecycling/home',
        element: <CulturalExchange_gemstonerecycling.Home/>,
        title: '宝石回收'
    },
    {
        path: '/culturalExchange_gemstonerecycling/recycleRecord',
        element: <CulturalExchange_gemstonerecycling.RecycleRecord/>,
        title: '回收记录'
    },
]

export default routes
